module.exports = "img/flags/AL.5420556.png";